module.exports = __webpack_public_path__ + "static/media/nominate-banner.85ebb538.png";